import React from 'react';
import PropTypes from 'prop-types';

import { TextInput, Label } from '@sopranodesign/pulse-components';

const RegexInput = ({ content, onChange }) => {
  const handleChange = event => {
    const regex = event.target.value;

    onChange({ regex });
  };

  return (
    <div>
      <Label htmlFor="regex">Regex to use</Label>
      <TextInput
        id="regex"
        placeholder="/email\\((.*?)\\)/"
        value={content.regex}
        onChange={handleChange}
      />
    </div>
  );
};

RegexInput.propTypes = {
  content: PropTypes.shape({
    regex: PropTypes.string.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default RegexInput;
